<template>
  <div>
    <b-card :title="$t('surgery.patient-surgery-consumables')">
      <b-card-text>
        <b-row>
          <!-- <b-col lg="4">
            <CategoryModal @category="assignCategory" />
          </b-col>
          <b-col v-if="sciFilter" lg="4">
            <AutoComplete
              :label="$t('surgery.consumables')"
              :placeholder="`${$t('common.select')} ${$t(
                'surgery.consumable'
              )}`"
              v-model="consumablesForm.item_id"
              param-query="search"
              :serializer="(val) => val"
              endpoint="item"
              text-title="name"
              :otherQuery="`filter[category_id]=${sciFilter}`"
            />
          </b-col> -->

          <div v-if="consumables.length > 0" class="chips-container mb-3">
            <b-badge
              v-for="(consumable, consIndex) in consumables"
              :key="consIndex"
              variant="info"
              class="chip-badge"
            >
              {{ consumable.item_name }} ({{ consumable.quantity }})
              <span class="chip-remove" @click="removeItem(consumable)">
                <feather-icon icon="XIcon" size="12" />
              </span>
            </b-badge>
          </div>
          <b-col lg="12">
            <b-row class="g-2 align-items-center">
              <b-col md="4" cols="12">
                <b-form-group class="mb-0">
                  <AutoComplete
                    v-model="selectedCategory"
                    :label="$t('warehouse.category')"
                    :placeholder="$t('warehouse.one-category')"
                    :serializer="(val) => val"
                    endpoint="category"
                    text-title="name"
                    :other-query="`filter[type]=hospital`"
                    @input="assignCategory"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="sciFilter" md="4" cols="12">
                <b-form-group class="mb-0">
                  <AutoComplete
                    v-model="selectedConsumable"
                    :label="$t('surgery.consumables')"
                    :placeholder="$t('surgery.select-consumable')"
                    param-query="search"
                    :serializer="(val) => val"
                    endpoint="item"
                    text-title="name"
                    :other-query="`filter[category_id]=${sciFilter}`"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2" cols="12">
                <b-form-group class="mb-0">
                  <b-form-input
                    v-model="consumableQuantity"
                    type="number"
                    size="sm"
                    :placeholder="$t('pharmacy.Quantity')"
                    min="1"
                    class="compact-input"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2" cols="12">
                <b-button
                  size="sm"
                  variant="primary"
                  :disabled="!selectedConsumable || !consumableQuantity"
                  block
                  class="add-btn"
                  @click="addConsumable"
                >
                  <feather-icon icon="PlusIcon" size="14" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card :title="$t('surgery.patient-surgery-consumables')">
      <b-table
        :items="consumables"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <b-button
          ref="myButton"
          :disabled="consumables.length === 0"
          class="mt-2"
          variant="primary"
          @click="submitItem"
        >
          {{ $t("common.submit") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
  BBadge,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    BCardText,
    vSelect,
    BBadge,
  },
  data() {
    return {
      sciFilter: null,
      selectedCategory: null,
      selectedConsumable: null,
      consumableQuantity: 1,

      loading: true,
      consumablesForm: {
        item_id: "",
        patient_card_surgery_id: this.$route.params.id,
        quantity: "",

        price: "",
      },

      tableColumns: [
        { key: "item_name", label: this.$t("common.name"), sortable: true },

        {
          key: "quantity",
          label: this.$t("pharmacy.Quantity"),
          sortable: true,
        },

        // { key: 'price', label: this.$t('common.price'), sortable: true },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      consumables: [],
      params: {
        form: {},
        path: "",
      },
    };
  },

  methods: {
    addConsumable() {
      if (this.selectedConsumable && this.consumableQuantity) {
        this.consumables.push({
          item_id: this.selectedConsumable.id,
          item_name: this.selectedConsumable.name,
          quantity: parseInt(this.consumableQuantity, 10),
          patient_card_surgery_id: this.$route.params.id,
          price: 0,
        });
        // Reset all fields after adding
        this.selectedCategory = null;
        this.selectedConsumable = null;
        this.consumableQuantity = 1;
        this.sciFilter = null;
      }
    },
    removeItem(item) {
      this.consumables = this.consumables.filter((drug) => drug !== item);
    },

    assignCategory(category) {
      if (category) {
        this.selectedConsumable = null;
        this.sciFilter = category.id;
      } else {
        this.sciFilter = null;
      }
    },

    submitItem() {
      this.consumables = this.consumables.map((drug) => ({
        ...drug,
        item_id: drug.item_id,
        price: 0,
      }));

      (this.params.form = { consumables: this.consumables }),
        (this.params.path = "/patientSurgeryConsumable"),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.$router.go(-1);

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Created",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.chip-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  cursor: default;
}

.chip-remove {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-left: 0.25rem;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.chip-remove:hover {
  opacity: 1;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
